__turbopack_context__.v({
  "metro": "Place-module-sass-module__J1gjiq__metro",
});
